import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentAssignment:JSON.parse(localStorage.getItem('currentAssignment')) || null,
    user:JSON.parse(localStorage.getItem('user')) || null,
    course:JSON.parse(localStorage.getItem('course')) || null,
    student:JSON.parse(localStorage.getItem('student')) || null,
    stuList:JSON.parse(localStorage.getItem('stuList')) || null,
    summary:JSON.parse(localStorage.getItem('summary')) || 0,
    pagination: {
      pageNum: 1,
      pageSize: 8,
    },
    sortParams: {//默认按照提交时间降序排列
      sortField: 'submitTime',
      sortOrder: 'descending',
    },
  },
  mutations: {
    setCurrentAssignment(state,param){
      state.currentAssignment = param;
      localStorage.setItem('currentAssignment',JSON.stringify(param));
    },
    clearCurrentAssignment(state) {
      console.log('Clearing current assignment...');
      state.currentAssignment = null;
      localStorage.removeItem('currentAssignment');
    },
    setUser(state, payload) {
      state.user = payload;
      localStorage.setItem('user',JSON.stringify(payload));
    },
    clearUser(state){
      console.log('Clearing current user...');
      state.user = null;
      localStorage.removeItem('user');
    },
    setCourse(state, payload) {
      state.course = payload;
      localStorage.setItem('course',JSON.stringify(payload));
    },
    clearCourse(state){
      console.log('Clearing current course...');
      state.course = null;
      localStorage.removeItem('course');
    },
    setStudent(state, payload) {
      state.student = payload;
      localStorage.setItem('student',JSON.stringify(payload));
    },
    clearStudent(state){
      console.log('Clearing current student...');
      state.student = null;
      localStorage.removeItem('student');
    },
    
    setStuList(state, payload) {
      state.stuList = payload;
      localStorage.setItem('stuList',JSON.stringify(payload));
    },
    
    clearStuList(state){
      console.log('Clearing current stuList...');
      state.stuList = null;
      localStorage.removeItem('stuList');
    },
    setPageNum(state, pageNum) {
      state.pagination.pageNum = pageNum;
    },
    setPageSize(state, pageSize) {
      state.pagination.pageSize = pageSize;
    },
    setSortField(state, sortField) {
      state.sortParams.sortField = sortField;
    },
    setSortOrder(state, sortOrder) {
      state.sortParams.sortOrder = sortOrder;
    },
    setSummary(state, payload) {
      state.summary = payload;
      localStorage.setItem('summary',JSON.stringify(payload));
    },
  },
  actions: {
    setCurrentAssignment({ commit }, param) {
      commit('setCurrentAssignment', param);
    },
    setUser({ commit }, user) {
      // 在登录时调用这个 action，并传递用户信息
      commit('setUser', user);
    },
    setCourse({ commit }, course) {
      // 在登录时调用这个 action，并传递用户信息
      commit('setCourse', course);
    },
    setStudent({ commit }, student) {
      // 在登录时调用这个 action，并传递用户信息
      commit('setStudent', student);
    },
    setStuList({ commit }, stuList) {
      // 在登录时调用这个 action，并传递用户信息
      commit('setStuList', stuList);
    },
    updatePageInfo({ commit }, { pageNum, pageSize }) {
      commit('setPageNum', pageNum);
      commit('setPageSize', pageSize);
    },
    updateSortParams({ commit }, { sortField, sortOrder }) {
      commit('setSortField', sortField);
      commit('setSortOrder', sortOrder);
    },
    setSummary({ commit }, summary) {
      // 在登录时调用这个 action，并传递用户信息
      commit('setSummary', summary);
    },
  },
  getters: {
    // 获取 menuParam 的值
    getCurrentAssignment: state => state.currentAssignment,
    getUser:(state)=> state.user,
    getCourse:(state) => state.course,
    getStudent:(state) => state.student,
    getStuList:(state) => state.stuList,
    getPageInfo:(state)=>state.pagination,
    getSortParams:(state)=>state.sortParams,
    getSummary:(state)=>state.summary
  },
})
export default store